import { Icon, Text } from "@chakra-ui/react";
import { PiKeyholeFill } from "react-icons/pi";
import { useTranslation } from "react-i18next";

const DontHavePermissionPage = () => {
    const { t } = useTranslation("translations");

    return (
        <div className="h-[100vh] flex flex-col justify-center items-center text-center">
            <div className="lock">
                <Icon as={PiKeyholeFill} w={80} h={80} color='teal.500'/>
            </div>
            <div className="message">
                <Text fontSize='30px' fontWeight="bold">{t("DONT_HAVE_NECESARRY_PERMISSION_PAGE")}</Text>
                <Text>{t("PLEASE_CONTACT_THE_ADMIN_IF_YOU_THNIK_YOU_NEED_THIS_PERMISSION")}</Text>
                <Text>{t("GO_TO_DASHBOARD")} <a href="/dashboard" className="text-teal-300 underline">{t("HERE")}</a>!</Text>
            </div>
        </div>
    )
}

export default DontHavePermissionPage;